import { createStore, CreateStore } from 'redux';
import { persistStore } from 'redux-persist';


import reducer from './reducer';


export const store = createStore(reducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ 
    && window.__REDUX_DEVTOOLS_EXTENSION__());

export const persistor = persistStore(store);


export default { store, persistor };




// import { createStore, CreateStore } from 'redux';

// import reducer from './reducer';


// export default createStore(reducer,
//     window.__REDUX_DEVTOOLS_EXTENSION__ 
//     && window.__REDUX_DEVTOOLS_EXTENSION__());


